import {ModalController} from '@ionic/angular';
import {MomentAdapter} from '../../../../shared/utils/moment.utils';
import {AppInjector} from '../../../../app-injector';
import {DialogController, DialogOptions} from '../../../common/dialog/dialogController';
import {IDialogComponent} from '../../../common/dialog/iDialog.component';
import {ComponentType} from '@angular/cdk/portal';
import {Dialog} from '../../../common/dialog/dialog';
import {
    CommunicationContentModelSaveDialogResult
} from '../../../communication/content-model/api/component/communication-content-model-save-dialog/communication-content-model-save-dialog.component';

export abstract class AbstractSelectComponent<Model> {

    dialogId;
    modalController;
    dialogController: DialogController;

    protected constructor() {
        const injector = AppInjector.injector;
        this.modalController = injector.get(ModalController);
        this.dialogController = injector.get(DialogController);
    }

    abstract addNewItem(value: any);

    abstract closeSelect();

    abstract getSelectInputValue(): string;

    newItemSelected<R, DialogInput, T extends IDialogComponent<DialogInput, R>>(
        newItemModalOptions: NewItemModalOptions<R, DialogInput, T>) {
        this.closeSelect();
        this.dialogController.open(newItemModalOptions.componentType,
            newItemModalOptions.dialogInput,
            newItemModalOptions.dialogOption).afterClosed()
            .subscribe((result: R) => {
                this.addNewItem(newItemModalOptions.valueNewItemMapper(result));
            });
    }
}


export interface NewItemModalOptions<R, DialogInput, T extends IDialogComponent<DialogInput, R>> {
    componentType: ComponentType<T>;
    dialogInput: DialogInput;
    dialogOption: DialogOptions;
    valueNewItemMapper: (result: R) => any;
}
